import { render } from "./respiratory-rate.vue?vue&type=template&id=022add20&scoped=true"
import script from "./respiratory-rate.vue?vue&type=script&lang=js"
export * from "./respiratory-rate.vue?vue&type=script&lang=js"

import "./respiratory-rate.vue?vue&type=style&index=0&id=022add20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022add20"]])

export default __exports__